import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { supabase } from "../lib/supabaseClient";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import "./JournalArticle.css";

const JournalArticle = () => {
  const { slug } = useParams();

  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchArticle = async () => {
      setLoading(true);
      setError("");
      setArticle(null);

      const { data, error } = await supabase
        .from("journal_articles")
        .select(`
          id,
          title,
          slug,
          excerpt,
          content,
          cover_image,
          category,
          published_at
        `)
        .eq("slug", slug)
        .eq("published", true)
        .single();

      if (error) {
        console.error("Error fetching journal article:", error);
        setError("Article not found.");
      } else {
        setArticle(data);
      }

      setLoading(false);
    };

    if (slug) {
      fetchArticle();
    }
  }, [slug]);

  const formatDate = (date) => {
    if (!date) return "";

    return new Date(date).toLocaleDateString("en-IN", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  if (loading) {
    return (
      <div className="journal-article-page">
        <Navbar />

        <main className="journal-article-main">
          <div className="journal-article-state">
            <div className="journal-spinner"></div>
            <p>Loading article...</p>
          </div>
        </main>

        <Footer />
      </div>
    );
  }

  if (error || !article) {
    return (
      <div className="journal-article-page">
        <Navbar />

        <main className="journal-article-main">
          <div className="journal-article-state journal-article-not-found">

            <span className="journal-article-state-mark">
              ✦
            </span>

            <h1>Article not found</h1>

            <p>
              The article you're looking for may have been
              unpublished or may no longer be available.
            </p>

            <Link
              to="/journal"
              className="journal-article-back-btn"
            >
              ← Back to Journal
            </Link>

          </div>
        </main>

        <Footer />
      </div>
    );
  }

  return (
    <div className="journal-article-page">
      <Navbar />

      <main className="journal-article-main">

        {/* Article Header */}
        <section className="journal-article-header">

          <div className="journal-article-header-inner">

            <Link
              to="/journal"
              className="journal-article-back"
            >
              ← Back to Journal
            </Link>

            <div className="journal-article-meta">

              {article.category && (
                <span className="journal-article-category">
                  {article.category}
                </span>
              )}

              {article.published_at && (
                <span className="journal-article-date">
                  {formatDate(article.published_at)}
                </span>
              )}

            </div>

            <h1>{article.title}</h1>

            {article.excerpt && (
              <p className="journal-article-excerpt">
                {article.excerpt}
              </p>
            )}

          </div>

        </section>

        {/* Cover Image */}
        {article.cover_image && (
          <div className="journal-article-cover">
            <img
              src={article.cover_image}
              alt={article.title}
            />
          </div>
        )}

        {/* Article Content */}
        <article className="journal-article-content">

          <div className="journal-article-body">

            {article.content
              ?.split("\n")
              .map((paragraph, index) => {
                if (!paragraph.trim()) {
                  return (
                    <div
                      key={index}
                      className="journal-article-spacer"
                    />
                  );
                }

                return (
                  <p key={index}>
                    {paragraph}
                  </p>
                );
              })}

          </div>

        </article>

        {/* Bottom Navigation */}
        <section className="journal-article-footer">

          <div className="journal-article-footer-inner">

            <span>
              Sudhamshu Ayurveda Journal
            </span>

            <Link to="/journal">
              Explore More Articles →
            </Link>

          </div>

        </section>

      </main>

      <Footer />
    </div>
  );
};

export default JournalArticle;